import { Mixpanel } from './Mixpanel';

const addMixpanel = requestHandler => (type, resource, params) => {
  const cleanName = type.replace('_', ' ').toLowerCase() + ' ' + resource;

  //Events

  if (resource === 'events') {
    //This is for get_list_events
    if (
      type.toLowerCase() === 'get_list' &&
      params.filter.hasOwnProperty('market_id')
    ) {
      Mixpanel.track(cleanName, { 'market id': params.filter.market_id });
    }

    //This is for get_one_event
    else if (type.toLowerCase() === 'get_one') {
      return requestHandler(type, resource, params).then(response => {
        Mixpanel.track(cleanName, {
          'market id': response.data.market_id,
          'event id': response.data.id,
          'event name': response.data.name,
          capacity: response.data.capacity,
        });
        return response;
      });
    }

    //This is to create_event
    //Also calls get_list and get_one
    else if (type.toLowerCase() === 'create') {
      Mixpanel.track(cleanName, {
        'market id': params.data.market_id,
        'event name': params.data.name,
        capacity: params.data.capacity,
        'start date': JSON.stringify(params.data.start_date),
      });
    }

    //This is to update_event
    else if (type.toLowerCase() === 'update') {
      let obj = {
        'market id': params.data.market_id,
        'event id': params.data.id,
        'event name': params.data.name,
        capacity: params.data.capacity,
        'start date': params.data.start_date,
      };

      if (
        JSON.stringify(params.data.name) !==
        JSON.stringify(params.previousData.name)
      ) {
        obj['previous event name'] = params.previousData.name;
        obj['new event name'] = params.data.name;
        delete obj['event name'];
      }

      if (
        JSON.stringify(params.data.capacity) !==
        JSON.stringify(params.previousData.capacity)
      ) {
        obj['previous capacity'] = params.previousData.capacity;
        obj['new capacity'] = params.data.capacity;
        delete obj['capacity'];
      }

      if (
        JSON.stringify(params.data.start_date) !==
        JSON.stringify(params.previousData.start_date)
      ) {
        obj['previous start date'] = params.previousData.start_date;
        obj['new start date'] = params.data.start_date;
        delete obj['start date'];
      }

      Mixpanel.track(cleanName, obj);
    }
  }

  //Venues
  else if (resource === 'venues') {
    //This is to get_one_venue
    if (type.toLowerCase() === 'get_one') {
      return requestHandler(type, resource, params).then(response => {
        Mixpanel.track(cleanName, {
          'market id': response.data.market_id,
          'venue id': response.data.id,
          'venue name': response.data.name,
          capacity: response.data.capacity,
        });
        return response;
      });
    }

    //This is to update venue
    else if (type.toLowerCase() === 'update') {
      let obj = {
        'market id': params.data.market_id,
        'venue id': params.data.id,
        capacity: params.data.capacity,
        'venue name': params.data.name,
      };
      if (
        JSON.stringify(params.data.name) !==
        JSON.stringify(params.previousData.name)
      ) {
        obj['previous venue name'] = params.previousData.name;
        obj['new venue name'] = params.data.name;
        delete obj['venue name'];
      }

      if (
        JSON.stringify(params.data.capacity) !==
        JSON.stringify(params.previousData.capacity)
      ) {
        obj['previous capacity'] = params.previousData.capacity;
        obj['new capacity'] = params.data.capacity;
        delete obj['capacity'];
      }

      Mixpanel.track(cleanName, obj);
    }

    //This is to create venues
    else if (type.toLowerCase() === 'create') {
      Mixpanel.track(cleanName, {
        'market id': params.data.market_id,
        'venue name': params.data.name,
        capacity: params.data.capacity,
        latitude: params.data.lat,
        longitude: params.data.lng,
        'venue address': params.data.address,
      });
    }
  }

  //Tncs
  else if (resource === 'tncs') {
    //This is to create tncs
    if (type.toLowerCase() === 'create') {
      return requestHandler(type, resource, params).then(response => {
        Mixpanel.track(cleanName, undefined);
        return response;
      });
    }

    //This is to update tncs
    else if (type.toLowerCase() === 'update') {
      return requestHandler(type, resource, params).then(response => {
        Mixpanel.track(cleanName, undefined);
        return response;
      });
    }
  }

  // This is for get_list_<resource> (Except for events resource)
  // Can't get a market_id
  else if (type.toLowerCase() === 'get_list' && resource !== 'events') {
    Mixpanel.track(cleanName, undefined);
  }

  //This is to create airports/subservices/geofences
  else if (
    type.toLowerCase() === 'create' &&
    resource !== 'events' &&
    resource !== 'venues' &&
    resource !== 'tncs'
  ) {
    return requestHandler(type, resource, params).then(response => {
      Mixpanel.track(cleanName, {
        'market id': params.data.market_id,
      });
      return response;
    });
  }

  //This is to update subservices/geofences/airports
  else if (
    type.toLowerCase() === 'update' &&
    resource !== 'events' &&
    resource !== 'venues' &&
    resource !== 'tncs'
  ) {
    return requestHandler(type, resource, params).then(response => {
      Mixpanel.track(cleanName, {
        'market id': params.data.market_id,
      });
      return response;
    });
  }

  // for other request types and resources, fall back to the default request handler
  return requestHandler(type, resource, params).then(response => {
    return response;
  });
};

export default addMixpanel;



// WEBPACK FOOTER //
// ./src/addMixpanel.js